'use client';

import { DownloadSection as KeziosDownloadSection } from '@kezios/design-system';
import { Button, Text } from '@mantine/core';
import { LinkWithQueryParams } from 'components/website/components/atoms/LinkWithQueryParams/LinkWithQueryParams';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

export const DownloadSection = ({
  currentLocale,
}: {
  currentLocale: string;
}) => {
  const t = useTranslations('section.download');
  return (
    <KeziosDownloadSection
      title={t('title')}
      descriptionFirstLine={t('description.firstLine')}
      descriptionSecondLine={t('description.secondLine')}
      cta={
        <>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.adobevideopartner.com/"
          >
            <Text
              variant="textMd.medium"
              c="gray.6"
              style={{ textDecoration: 'underline' }}
            >
              {t('description.adobe')}
            </Text>
          </a>
          <Button
            variant="filled"
            w={'fit-content'}
            component={LinkWithQueryParams}
            locale={currentLocale}
            href="/download/"
          >
            {t('cta')}
          </Button>
        </>
      }
      image={
        <Image
          style={{
            objectFit: 'contain',
            backgroundColor: 'var(--mantine-color-gray-0)',
            boxShadow: 'none',
            scale: 0.95,
          }}
          src="/static/team/AutoCut_Team_1.png"
          alt="DownloadSection image"
          fill
        />
      }
    />
  );
};
